'use client'

import type { MouseEvent } from 'react'

type HeroScrollButtonProps = {
  className: string
  label: string
  ariaLabel: string
}

export default function HeroScrollButton({ className, label, ariaLabel }: HeroScrollButtonProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()

    const target = document.getElementById('service-intro')
    if (!target) {
      return
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' })
  }

  return (
    <a href="#service-intro" className={className} aria-label={ariaLabel} onClick={handleClick}>
      <span>{label}</span>
    </a>
  )
}
